import { Component, OnInit } from '@angular/core';
import { WebPage } from '../../shared/web-page';
import { MessageService } from 'primeng/components/common/messageservice';
import { Router, ActivatedRoute } from '@angular/router';
import { ArquivoService } from '../../shared/services/arquivo.service';
import { ConfirmationService } from 'primeng/primeng';
import {
  AbstractControl,
  FormArray,
  Validators,
  FormGroup,
  FormBuilder
} from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { DocumentoAssinadoService } from '../../shared/services/documento-assinado.service';
import { EnumTipoArquivo } from '../../../models/tipoArquivo';


@Component({
  selector: 'sispac-inserir-documentos-assinados',
  templateUrl: './inserir-documentos-assinados.component.html',
  styleUrls: ['./inserir-documentos-assinados.component.css']
})
export class InserirDocumentosAssinadosComponent extends WebPage
  implements OnInit {
  form: FormGroup;
  idCandidato;
  tipoArquivo;
  idTipoArquivo;
  documentosAssinados;

  get arquivos() {
    return this.form.get('arquivos') as FormArray;
  }

  constructor(
    messageService: MessageService,
    private _router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private arquivoService: ArquivoService,
    private confirmationService: ConfirmationService,
    private documentoService: DocumentoAssinadoService
  ) {
    super(messageService);

    this.route.paramMap.subscribe(params => {
      this.idCandidato = params.get('idCandidato');

      this.form = this.fb.group({
        idCandidato: [this.idCandidato],
        arquivos: new FormArray([])
      });
    });
  }

  ngOnInit() {
    this.getTipoArquivo();
    this.getDocumentos();
  }

  myUploader(event, fileUpload): void {
    console.log('My File upload', event);

    if (this.idTipoArquivo === undefined) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Selecione um tipo!'
      });
      fileUpload.clear();
      return;
    }

    if (event.files.length === 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Arquivo não inserido!'
      });
      fileUpload.clear();
      return;
    }

    const fileToUpload = event.files[0];
    const input = new FormData();
    input.append('arquivo', fileToUpload);
    input.append('idCandidato', this.idCandidato);
    input.append('idTipoArquivo', this.idTipoArquivo);

    this.arquivoService
      .upload(input)
      .finally(() => (this.isLoading = false))
      .subscribe(
        res => {
          this.getTipoArquivo();
          this.getDocumentos();
          fileUpload.clear();
        },
        error => {
          fileUpload.clear();
          this.gerenciaErro(error);
        }
      );
  }

  getDocumentos() {
    this.documentoService
      .getByIdCadidato(this.idCandidato)
      .finally(() => (this.isLoading = false))
      .subscribe(
        documentosAssinados => {
          this.documentosAssinados = documentosAssinados;
          console.log(documentosAssinados);
        },
        error => this.gerenciaErro(error)
      );
  }

  selectOption(value) {
    this.idTipoArquivo = value;
  }

  downloadArquivo(idArquivo, nomeArquivo) {
    console.log(idArquivo);
    console.log(nomeArquivo);
    this.arquivoService.downloadArquivo(idArquivo, nomeArquivo);
  }

  removeArquivosDoBanco(idArquivo: string) {
    // console.log(event);
    // console.log(event.path[1].hidden);
    // event.path[1].hidden = true;
    // console.log(event.path[1].hidden);

    this.confirmationService.confirm({
      message: 'Tem certeza que deseja excluir?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.arquivoService
          .removeArquivo(idArquivo)
          .finally(() => (this.isLoading = false))
          .subscribe(
            () => {
              this.getTipoArquivo();
              this.getDocumentos();
            },
            error => this.gerenciaErro(error)
          );
      }
    });
  }

  podeExcluirArquivo(idTipoArquivo:string){
    idTipoArquivo = idTipoArquivo.toUpperCase();
    if(EnumTipoArquivo.NotaTecnicaTermoAditivo === idTipoArquivo || EnumTipoArquivo.TermoAditivoAssinado === idTipoArquivo){
      return false;
    }
    else{
      return true;
    }

  }

  cancelar() {
    this.confirmationService.confirm({
      message: 'Deseja cancelar?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        let arquivosNovos: AbstractControl[];
        arquivosNovos = this.arquivos.controls.filter(
          arquivo => !arquivo.value.isOld
        );
        this._router.navigate(['/gerenciar-etapas']);
      }
    });
  }

  getTipoArquivo() {
    this.arquivoService
      .getTipoArquivo('Documento_Assinado', this.idCandidato)
      .finally(() => (this.isLoading = false))
      .subscribe(
        tipoArquivo => {
          this.tipoArquivo = tipoArquivo;
        },
        error => this.gerenciaErro(error)
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/candidato/inserir-documentos-assinados/inserir-documentos-assinados.component.ts